import _ from 'lodash';
import moment from 'moment';

const initialState = {
	cart: null,
	cartBackup: null,
	cartBackOrders:null,
	availability: [],
	orderability: [],
	prices: [],
	cartPimData: null,
	services_prices:[],
	// showIFWarningMessage: false,
};

export default function cart(state = initialState, action) {
    switch (action.type) {
		// case 'SHOW_IF_WARNING_MESSAGE':
		// 	return {
		// 		...state,
		// 		showIFWarningMessage: action.data
		// 	}
	    case 'SAVE_TO_CART':
			const responseObject = action.data.responseObject;
			if(responseObject && responseObject.cartItems) {
				responseObject.cartItems = responseObject.cartItems.sort((a, b) => {
					if(moment(a.createdDate).isBefore(moment(b.createdDate))) {
						return -1;
					} else if(moment(b.createdDate).isBefore(moment(a.createdDate))) {
						return 1;
					} else {
						return 0
					}
				});
			}
	        return { ...state,
	            cart: {
					...action.data,
					responseObject
				}
	        }
		case 'SAVE_TO_CART_BACKUP':
			const responseObject1 = JSON.parse(JSON.stringify(action.data.responseObject));
			if(responseObject1 && responseObject1.cartItems) {
				responseObject1.cartItems = responseObject1.cartItems.sort((a, b) => {
					if(moment(a.createdDate).isBefore(moment(b.createdDate))) {
						return -1;
					} else if(moment(b.createdDate).isBefore(moment(a.createdDate))) {
						return 1;
					} else {
						return 0
					}
				});
			}
	        return { ...state,
	            cartBackup: {
					...action.data,
					responseObject: responseObject1
				}
	        }
		case 'SAVE_TO_CART_BACKORDERS' : 
		const responseObject2 = JSON.parse(JSON.stringify(action.data.responseObject));
			if(responseObject2 && responseObject2.cartItems) {
				responseObject2.cartItems = responseObject2.cartItems.sort((a, b) => {
					if(moment(a.createdDate).isBefore(moment(b.createdDate))) {
						return -1;
					} else if(moment(b.createdDate).isBefore(moment(a.createdDate))) {
						return 1;
					} else {
						return 0
					}
				});
			}
	        return { ...state,
	            cartBackOrders: {
					...action.data,
					responseObject: responseObject2
				}
	        }
	    case 'DELETE_FROM_CART':
	        return {
	            ...state,
	            cart: action.data
	        }
		case 'DELETE_ALL_FROM_CART':
	        return { ...state,
	            cart: null
	        }
		case 'UPDATE_CART_ORDER_POINTS':
			return {...state,
				cartPimData: action.data
			}
		case 'RESET_AVAILABILITY_TO_CART':
			return {...state,
				availability: []
			}
        case 'SAVE_PRODUCT_AVAILABILITY_CART':
			var availability = [];
			if(action.data !== null && action.data !== ''){
				action && action.data && action.data.responseObject.length >0 && action.data.responseObject.forEach((item, index) => {
					availability.push(item);
				});
			}
			return { ...state,
				availability
			};
		case 'REMOVE_AVAILABILITY_FROM_CART':
			return {
			...state,
			availability: state.availability.filter(avail => avail.sku !== action.data[0].item
			)
		};
		case 'SAVE_ORDERABILITY_TO_CART':
			var orderability = [];
			if(action.data !== null && action.data !== ''){
				action && action.data && action.data.responseObject.length > 0 && action.data.responseObject.forEach(item => {
					orderability.push(item);
				});
			}
			return { ...state,
				orderability
			};
		case 'SAVE_PRICES_TO_CART':
			var prices = [];
			if(action.data && action.data.responseObject && action.data.responseObject.items.length > 0){
				action.data.responseObject.items.map((item, index) =>{
					return prices.push(item)
				});
			}
			return { ...state,
				prices: state.prices.concat(prices)
			};
		case 'UPDATE_PRICES_TO_CART':
			return {...state,
				prices: action.data
			}
		case 'RESET_PRICES_TO_CART':
			return {...state,
				prices: []
			}
		case 'SAVE_SERVICES_PRICES_TO_CART':
			var services_prices = [];
			if (action.data.responseObject) {
				// TO DO : Temporary conversion from json string to json
				action.data.responseObject = JSON.parse(action.data.responseObject);
			}
			if(action.data && action.data.responseObject && action.data.responseObject.items.length > 0){
				action.data.responseObject.items.map((item, index) =>{
					return services_prices.push(item)
				})
			}
			return { ...state,
				services_prices:state.services_prices.concat(services_prices)
			};
		case 'RESET_SERVICES_PRICES_TO_CART':
			return { ...state,
				services_prices: []
			};
		case 'RESET_CART_REDUCERS':
			return initialState;
	    default:

	        return state;
    }
}


// WEBPACK FOOTER //
// ./src/App/redux/reducers/cart.js